import React, { useEffect, useState } from 'react';
import { useWeb3 } from '../context/Web3Context';
import InvestmentList from '../components/Investments/InvestmentList';
import Card from '../components/Common/Card';
import PageLoader from '../components/Loader/PageLoader';

const MyInvestments = () => {
  const { contract, account, userId } = useWeb3();

  const [loading, setLoading] = useState(true);
  const [investments, setInvestments] = useState([]);
  const [reloadKey, setReloadKey] = useState(0);

  const load = async () => {
    if (!contract || !userId) { setLoading(false); return; }
    try {
      const r = await contract.getUserInvestmentDetails(userId);
      const list = [];
      for (let i = 0; i < r.amounts.length; i++) {
        list.push({
          index: i,
          amount: r.amounts[i],
          timestamp: r.timestamps[i],
          roiEarned: r.roiEarned[i],
          maxROI: r.maxROIs[i],
          maturityTime: r.maturityTimes[i],
          active: r.active[i],
          principalWithdrawn: r.principalWithdrawn[i],
          plan: Number(r.plans[i]),
          investmentType: Number(r.investmentTypes[i])
        });
      }
      setInvestments(list);
    } catch (e) {
      // silent
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [contract, account, userId, reloadKey]);

  if (loading) return <PageLoader text="Loading Stakes" />;

  if (!account) {
    return (
      <Card>
        <div className="empty-state">
          <div className="empty-state-icon">◌</div>
          <div className="empty-state-text">Connect your wallet</div>
        </div>
      </Card>
    );
  }

  return (
    <div>
      <h1 className="page-title">My Stakes</h1>
      <p className="page-subtitle">Active and past investments · {investments.length} total</p>

      <InvestmentList investments={investments} onChange={() => setReloadKey((k) => k + 1)} />
    </div>
  );
};

export default MyInvestments;
